'use strict';

class ReportsListController {
  constructor($scope,
              $q,
              $filter,
              $state,
              utils,
              ReportsService) {
    const $t = $filter('translate');

    const CURRENT_ORG_LOCAL_STORAGE_KEY = 'Organizations-Current';
    $scope.orgInfo = utils.getStorageItem(CURRENT_ORG_LOCAL_STORAGE_KEY);
    const FILTER_LOCAL_STORAGE_KEY = 'Filter-Reports' + ($scope.orgInfo ? '-' + $scope.orgInfo.id : '');

    $scope.searchVal = '';
    $scope.reports = void 0;
    $scope.loading = false;
    $scope.cacheFilter = false;

    angular.extend($scope, {
      viewReport: viewReport,
      initFilterFromCache: initFilterFromCache,
      toggleGlobalReports: toggleGlobalReports,
      gotoSystemStatus: gotoSystemStatus,
    });

    init();

    function init() {
      $scope.loading = true;

      $scope.initFilterFromCache();

      $scope.$watch('searchVal', function() {
        saveFilter();
      });

      $q.all([
        initReports()
      ]).then((data) => {
        processReports(data[0]);
      }, () => {
        $scope.loading = false;
      });
    }

    function initReports() {
      $scope.loading = true;
      let orgId = $scope.searchGlobalReports ? void 0 : $scope.orgInfo?.id;
      let params = {
        organizationId: orgId,
        analytic: false // Skip analytic reports
      };

      return ReportsService.getAvailableReports(params)
        .then(data => data?.reports || [])
        .catch(err => {
          utils.handleApiError(err);
          $scope.reports = [];
        });
    }

    /**
     * Enrich report data model
     */
    function processReports(data) {
      if (!data || !data.length) {
        $scope.reports = [];
        $scope.loading = false;
        return;
      }

      // Reports groups with default one
      let reportGroups = [{
        id: 999,
        name: $t('reports.list.defaultGroup.title'),
        description: $t('reports.list.defaultGroup.desc'),
        notificationCategory: 0,
        reports: [],
      }];

      data.forEach(report => {
        if (report.reportGroups && report.reportGroups.length > 0) {
          report.reportGroups.forEach(group => {
            reportGroups.find(item => item.id === group.id) || reportGroups.push({
              id: group.id,
              name: group.name,
              description: group.description,
              notificationCategory: group.notificationCategory,
              reports: [],
            });

            // Add report group ID into report data
            report.groupId = group.id;

            // Get report schedule
            group.schedule && (report.schedule = group.schedule);

            // Push report into specific group
            let reportGroupId = reportGroups.findIndex(item => item.id === group.id);
            reportGroups[reportGroupId].reports.push(report);
          });
        } else {

          // Push to default group
          reportGroups[0].reports.push(report);
        }
      });

      // Return sorted report groups
      $scope.reports = $filter('orderBy')(reportGroups, 'id');
      $scope.loading = false;
    }

    function saveFilter() {
      let params = {
        searchVal: $scope.searchVal,
        globalReports: $scope.searchGlobalReports
      };
      utils.setStorageItem(FILTER_LOCAL_STORAGE_KEY, params);
    }

    function initFilterFromCache() {
      let params = utils.getStorageItem(FILTER_LOCAL_STORAGE_KEY);
      if (params) {
        $scope.searchVal = params.searchVal;
        $scope.searchGlobalReports = params.globalReports;
      }
    }

    function toggleGlobalReports() {
      $scope.searchGlobalReports = !$scope.searchGlobalReports;
      $scope.searchVal = '';
      saveFilter();

      initReports()
        .then(data => {
          processReports(data);
        });
    }

    function viewReport(report) {
      if (!report || !report.id) {
        return;
      }
      $state.go('main.reports.view', {
        reportId: report.id,
        global: $scope.searchGlobalReports,
        report: report
      });
    }

    function gotoSystemStatus() {
      $state.go('main.reports.status');
    }

  }
}

export default angular
  .module('main.reportsList.controller', [])
  .controller('ReportsListController', ReportsListController)
  .name;
